const en = {
  app: { name: "MyWeddingWiz.com.com" },
  nav: {
    home: "Home", vendors: "Vendors", venues: "Venues", planningTools: "Planning Tools",
    about: "About", contact: "Contact", login: "Login", register: "Register",
    dashboard: "Dashboard", logout: "Logout",
    myWedding: "My Wedding", guestList: "Guest List", budget: "Budget",
    checklist: "Checklist", bookings: "Bookings", messages: "Messages",
    settings: "Settings", websiteBuilder: "Website Builder",
    vendorDashboard: "Dashboard", vendorProfile: "Business Profile",
    vendorBookings: "Bookings", vendorCalendar: "Availability",
    vendorMessages: "Messages", vendorSettings: "Settings"
  },
  common: {
    save: "Save", cancel: "Cancel", delete: "Delete", edit: "Edit", add: "Add",
    search: "Search", loading: "Loading...", noResults: "No results found",
    confirm: "Confirm", back: "Back", next: "Next", submit: "Submit", close: "Close",
    view: "View", create: "Create", update: "Update", details: "Details",
    status: "Status", actions: "Actions", all: "All", filter: "Filter", sort: "Sort",
    logout: "Logout", refreshPage: "Refresh Page", somethingWrong: "Something went wrong"
  },
  buttons: { learnMore: "Browse Vendors", getStarted: "Get Started", bookNow: "Book Now", viewDetails: "View Details", seeAll: "See All" },
  home: {
    hero: {
      title: "Plan Your Dream Wedding",
      subtitle: "Your all-in-one wedding planning platform. Find the best vendors, build your wedding website, manage guests, and track your budget — all in one place.",
      cta: "Get Started Free"
    },
    features: {
      title: "Everything You Need to Plan Your Wedding",
      subtitle: "From finding vendors to managing your guest list, we've got you covered.",
      vendors: { title: "Find Trusted Vendors", desc: "Browse hundreds of verified wedding professionals — photographers, caterers, decorators and more." },
      website: { title: "Wedding Website", desc: "Create a beautiful wedding website to share your love story, event details, and collect RSVPs." },
      guests: { title: "Guest Management", desc: "Manage your guest list, track RSVPs, organize family groups, and plan seating arrangements." },
      budget: { title: "Budget Tracker", desc: "Stay on top of your wedding budget with category-wise tracking, vendor payments, and spending insights." }
    },
    categories: { title: "Browse by Category", subtitle: "Find the perfect professionals for every aspect of your wedding." },
    cta: { title: "Ready to Start Planning?", subtitle: "Join thousands of couples who planned their perfect wedding with MyWeddingWiz.com.", button: "Create Your Free Account" }
  },
  footer: {
    description: "Your complete wedding planning platform.",
    tagline: "Making wedding planning beautiful, organized, and stress-free.",
    quickLinks: "Quick Links", forVendors: "For Vendors", support: "Support", legal: "Legal",
    vendorSignup: "Become a Vendor", vendorLogin: "Vendor Login",
    helpCenter: "Help Center", faq: "FAQ", resources: "Resources",
    privacyPolicy: "Privacy Policy", termsOfService: "Terms of Service",
    copyright: "© {{year}} MyWeddingWiz.com.com. All rights reserved."
  },
  categories: {
    photography: "Photography", videography: "Videography", catering: "Catering",
    florists: "Florists", musicDjs: "Music & DJs", weddingPlanners: "Wedding Planners",
    makeupHair: "Makeup & Hair", cakesDesserts: "Cakes & Desserts"
  },
  auth: {
    loginTitle: "Welcome Back", loginSubtitle: "Sign in to your account",
    registerTitle: "Create Account", registerSubtitle: "Start planning your wedding",
    email: "Email Address", password: "Password", confirmPassword: "Confirm Password",
    firstName: "First Name", lastName: "Last Name", phone: "Phone Number",
    forgotPassword: "Forgot Password?", rememberMe: "Remember me", noAccount: "Don't have an account?",
    hasAccount: "Already have an account?", signUp: "Sign Up", signIn: "Sign In",
    accountType: "Account Type", couple: "Couple", vendor: "Vendor",
    forgotTitle: "Forgot Password", sendResetLink: "Send Reset Link",
    resetTitle: "Reset Password", newPassword: "New Password", backToLogin: "Back to Login",
    emailPlaceholder: "Email address", passwordPlaceholder: "Password",
    confirmPlaceholder: "Confirm password", firstNamePlaceholder: "First name", lastNamePlaceholder: "Last name",
    invalidEmail: "Invalid email address", emailRequired: "Email is required",
    passwordRequired: "Password is required", passwordMin: "Minimum 8 characters",
    confirmRequired: "Please confirm password", passwordMismatch: "Passwords do not match",
    firstNameRequired: "First name is required"
  },
  settings: {
    title: "Settings", profileTab: "Profile", passwordTab: "Password", accountTab: "Account",
    firstName: "First Name", lastName: "Last Name", phone: "Phone",
    currentPassword: "Current Password", newPassword: "New Password",
    confirmNewPassword: "Confirm New Password",
    changePassword: "Change Password", updateProfile: "Update Profile",
    personalInfo: "Personal Information", saveChanges: "Save Changes", dangerZone: "Danger Zone"
  },
  register: {
    title: "Create Account", subtitle: "Start planning your wedding",
    firstName: "First Name", lastName: "Last Name", email: "Email Address",
    password: "Password", confirmPassword: "Confirm Password",
    accountType: "Account Type", couple: "Couple", vendor: "Vendor",
    hasAccount: "Already have an account?", signIn: "Sign In", signUp: "Sign Up"
  },
  dashboard: {
    title: "Dashboard", welcomeBack: "Welcome back", overview: "Overview",
    guestsCard: "Guests", budgetCard: "Budget", checklistCard: "Checklist", vendorsCard: "Vendors",
    attending: "Attending", pending: "Pending", declined: "Declined",
    used: "used", complete: "complete", confirmed: "Confirmed",
    rsvpOverview: "RSVP Overview", budgetOverview: "Budget Overview",
    upcomingTasks: "Upcoming Tasks", quickActions: "Quick Actions",
    totalBudget: "Total Budget", spent: "Spent", paid: "Paid", remaining: "Remaining",
    createWedding: "Create My Wedding", createWeddingDesc: "Set up your wedding details to get started",
    daysToGo: "days to go", married: "Married!", weddingDay: "It's your wedding day!"
  },
  myWedding: {
    title: "My Wedding", partnerFirst: "Partner's First Name", partnerLast: "Partner's Last Name",
    weddingDate: "Wedding Date", venue: "Venue", venueName: "Venue Name", venueCity: "Venue City",
    currency: "Currency", estimatedBudget: "Estimated Budget", estimatedGuests: "Estimated Guests",
    weddingTheme: "Wedding Theme", notes: "Notes", saveChanges: "Save Changes",
    createWedding: "Create Wedding", updateWedding: "Update Wedding"
  },
  guestList: {
    title: "Guest List", addGuest: "Add Guest", editGuest: "Edit Guest",
    firstName: "First Name", lastName: "Last Name", email: "Email", phone: "Phone",
    rsvpStatus: "RSVP Status", attending: "Attending", pending: "Pending", maybe: "Maybe",
    bride: "Bride", groom: "Groom", mutual: "Mutual",
    searchGuests: "Search guests...", noGuests: "No guests yet",
    totalGuests: "Total Guests", attendingCount: "Attending", pendingCount: "Pending"
  },
  budget: {
    title: "Budget Tracker", addItem: "Add Item", editItem: "Edit Item",
    itemName: "Item Name", category: "Category", estimatedCost: "Estimated Cost",
    actualCost: "Actual Cost", paidAmount: "Paid Amount", isPaid: "Paid",
    totalEstimated: "Total Estimated", totalActual: "Total Actual",
    totalPaid: "Total Paid", remaining: "Remaining", overBudget: "Over Budget",
    noItems: "No budget items yet", addFirst: "Add your first budget item"
  },
  checklist: {
    title: "Wedding Checklist", addTask: "Add Task", editTask: "Edit Task",
    taskName: "Task Name", dueDate: "Due Date", priority: "Priority",
    completed: "Completed", incomplete: "Incomplete",
    high: "High", medium: "Medium", low: "Low",
    noTasks: "No tasks yet", addFirst: "Add your first task"
  },
  msgPanel: {
    title: "Messages", conversations: "Conversations",
    noConversations: "No conversations yet",
    noConversationsDesc: "When you message a vendor, conversations will appear here.",
    selectConversation: "Select a conversation to start chatting",
    typePlaceholder: "Type a message..."
  },
  bookings: {
    title: "My Bookings", bookingNumber: "Booking #",
    package: "Package", eventDate: "Event Date", total: "Total",
    paid: "Paid", status: "Status", details: "Details",
    noBookings: "No bookings yet", noBookingsDesc: "Browse vendors and book services.",
    totalBookings: "Total Bookings", totalCost: "Total Cost",
    pending: "Pending", confirmed: "Confirmed", completed: "Completed", cancelled: "Cancelled"
  },
  vendors: {
    title: "Wedding Vendors", subtitle: "Find trusted professionals for every aspect of your wedding",
    searchPlaceholder: "Search vendors, cities...",
    noVendors: "No vendors found", adjustFilters: "Try adjusting your filters.",
    verified: "Verified", featured: "Featured",
    topRated: "Top Rated", priceLowHigh: "Price: Low-High", priceHighLow: "Price: High-Low", byName: "Name",
    filterByCity: "Filter by city...", about: "About", packages: "Packages", gallery: "Gallery",
    reviews: "Reviews", quickInfo: "Quick Info", startingAt: "Starting at",
    priceRange: "Price Range", location: "Location",
    sendMessage: "Send Message", contactInfo: "Contact", services: "Services"
  },
  venues: {
    title: "Wedding Venues", subtitle: "Discover stunning venues for your perfect day",
    searchPlaceholder: "Search venues, cities...",
    noVenues: "No venues found", filterByCity: "Filter by city...",
    capacity: "Capacity", pricePerPlate: "Price/Plate", type: "Type",
    amenities: "Amenities", about: "About", quickInfo: "Quick Info",
    estimatedCost: "Estimated Cost", addToWedding: "Add to My Wedding"
  },
  planning: {
    title: "Planning Tools", subtitle: "Everything you need to plan your dream wedding, all in one place.",
    yourToolkit: "Your Planning Toolkit", timeline: "Wedding Planning Timeline",
    getStartedFree: "Get Started Free", readyToStart: "Ready to start planning?",
    createFreeAccount: "Create a free account to access all planning tools.",
    tools: {
      myWedding: "My Wedding", myWeddingDesc: "Set up your wedding details.",
      guestList: "Guest List", guestListDesc: "Manage guests and track RSVPs.",
      budget: "Budget Tracker", budgetDesc: "Track costs and payments.",
      checklist: "Checklist", checklistDesc: "58+ tasks from 12 months to wedding day.",
      website: "Wedding Website", websiteDesc: "Create a beautiful wedding website.",
      bookings: "Bookings", bookingsDesc: "Manage vendor bookings and payments.",
      messages: "Messages", messagesDesc: "Chat with your booked vendors.",
      settings: "Settings", settingsDesc: "Update profile and preferences."
    }
  },
  vendorPortal: {
    dashboard: "Vendor Dashboard", editProfile: "Edit Profile",
    totalBookings: "Total Bookings", pending: "Pending", confirmed: "Confirmed",
    rating: "Rating", recentBookings: "Recent Bookings", quickActions: "Quick Actions",
    profileTitle: "My Profile", businessInfo: "Business Info",
    saveChanges: "Save Changes", bookingsTitle: "Bookings",
    calendarTitle: "Calendar", revenue: "Revenue"
  }
};

export default en;
